const CallWithUs = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#0460CC"
      d="m11.546 9.463-3.06-6.597-4.61 4.858.153.762c.608 3.051 2.04 5.677 4.277 7.85 2.234 2.169 4.925 3.551 8.047 4.138l.728.137 5.165-4.634-6.737-2.909-1.525 1.631-.081-.043c-.892-.483-1.651-1.035-2.282-1.656l-.203-.204a12.385 12.385 0 0 1-1.466-1.846l-.033-.052 1.627-1.435ZM8.055 5.5l1.66 3.579L8 10.592c.717 1.338 1.573 2.497 2.57 3.477.934.92 2.093 1.698 3.478 2.335l.28.126 1.556-1.666 3.617 1.561L16.63 19c-2.835-.533-5.258-1.778-7.279-3.74-1.953-1.896-3.216-4.158-3.794-6.793L5.5 8.193 8.054 5.5Z"
    />
  </svg>
);
export default CallWithUs;
